import { FC } from 'react';
import { AdminCardContent } from 'containers/admin';
import { AdminCardLayout } from 'pages/atoms';

const AdminCardContentPage: FC = () => {
  return (
    <AdminCardLayout>
      <AdminCardContent />
    </AdminCardLayout>
  );
};

export default AdminCardContentPage;
